export default __webpack_public_path__ + "fm_logo_rgb.png?a3ae85edf7f3c9b74145c77ddc27c135";